import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { SURFACE, TEXT } from "../../dark-theme/palette";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function Unauthorized() {
    useEffect(() => {
        trackEvent("entered", { name: "Unauthorized" });
    }, []);

    return (
        <Box sx={{ flexGrow: 1, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Grid container spacing={0}>
                <Grid
                    size={{ xs: 12 }}
                    sx={{
                        padding: "80px 20px",
                        color: TEXT.primary,
                        backgroundColor: SURFACE.card,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                >
                    <Box sx={{ maxWidth: "600px" }}>
                        <Typography variant="h2" sx={{ color: TEXT.primary, fontSize: "48px", fontWeight: 600, mb: 3 }}>
                            Unauthorized Access
                        </Typography>
                        <Typography variant="body1" sx={{ color: TEXT.primary, fontSize: "18px", mb: 4 }}>
                            You don't have permission to access this page. If you believe this is an error, please contact your administrator.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
